import {
  ModalDialog,
  ModalDialogActions,
  ModalDialogContent,
  ModalDialogDescription,
  ModalDialogFooter,
  ModalDialogHeader,
  ModalDialogTitle,
} from '@/components/ModalDialog'
import { Button } from '@/components/Button'
import styles from './CallCenterAssistance.module.css'
import { IconButton } from '@/components/IconButton'
import logoUrl from '@/assets/misc/img_taxfyle-symbol.svg'
import { formatUSPhoneNumber } from '@/utils/phone-number-util'

interface CallSalesRepDialogProps {
  isOpen: boolean
  onClose: () => void
  phoneNumber: string
}

export function CallSalesRepDialog({
  isOpen,
  onClose,
  phoneNumber,
}: CallSalesRepDialogProps) {
  return (
    <ModalDialog size="lg" isOpen={isOpen} onClose={onClose}>
      <ModalDialogHeader textAlign="center">
        <img className={styles.logoImage} src={logoUrl} alt="Taxfyle logo" />
        <ModalDialogTitle>It's time to talk, call us now</ModalDialogTitle>
        <ModalDialogDescription>
          We are ready to assist you Monday - Friday 9-5pm EST
        </ModalDialogDescription>
      </ModalDialogHeader>
      <ModalDialogContent>
        <div className={styles.content}>
          <h1 className="text-headline-lg">
            {formatUSPhoneNumber(phoneNumber)}
          </h1>
          <IconButton
            label="Copy number"
            onPress={() => navigator.clipboard.writeText(phoneNumber)}
            name="copy"
          />
        </div>
      </ModalDialogContent>
      <ModalDialogFooter>
        <ModalDialogActions>
          <Button label="Close" variant="outline" onPress={onClose} />
        </ModalDialogActions>
      </ModalDialogFooter>
    </ModalDialog>
  )
}
